export default {
    data() {
        return {
            searchSites: [
                { name: 'Discogs', url: 'https://www.discogs.com/search/?q=' },
                { name: 'Gripsweat', url: 'https://gripsweat.com/search/?query=' },
                { name: 'Popsike', url: 'https://www.popsike.com/php/quicksearch.php?searchtext=' },
                { name: 'eBay', url: 'https://www.ebay.com/sch/Records-/176985/i.html?_nkw=' },
                // { name: 'Jellyfish', url: 'https://jellyfishrecords.com/?post_type=product&title=1&excerpt=1&content=1&categories=1&attributes=1&tags=1&sku=1&ixwps=1&s=' },
                { name: 'Amazon', url: 'https://www.amazon.com/s?i=music-intl-ship&k=vinyl+' },
                { name: 'Amazon UK', url: 'https://www.amazon.co.uk/s?i=music-intl-ship&k=vinyl+'}
            ],
            searchSitesArray: ['Discogs', 'Gripsweat', 'Popsike', 'eBay', 'Amazon', 'Amazon UK']
        }
    }
}